/**
 * Render the final JSX of PopoverTrigger
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderPopoverTrigger_unstable", {
    enumerable: true,
    get: function() {
        return renderPopoverTrigger_unstable;
    }
});
const renderPopoverTrigger_unstable = (state)=>{
    return state.children;
};
